import { AxiosInstance } from 'axios'

import { TableColumnSortDirection } from '@percent/lemonade'

export type TemplatesServiceCapabilities = {
  percentClient: AxiosInstance
}

export enum TemplateStatus {
  Active = 'active',
  Archived = 'archived'
}

export type TemplateSortField = 'name' | 'createdAt' | 'updatedAt'

export type TemplateAccountProfile = {
  id: string
  fullName?: string
  email?: string
}

export type GetTemplatesListBaseProps = {
  page?: number | null
  pageSize?: number | null
  query?: string | null
  status?: TemplateStatus[] | null
  sort?: TemplateSortField | null
  direction?: TableColumnSortDirection | null
}

export type TemplateBase = {
  id: string
  name: string
  status: TemplateStatus
  isDefault: boolean
  createdBy: string
  createdByProfile?: TemplateAccountProfile
  updatedBy?: string
  updatedByProfile?: TemplateAccountProfile
  createdAt: string
  updatedAt: string
}
